import { Nullable } from "@core/domain/types/nullable.type";
import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { EntityRepository } from "@entity/data/repositories/entity.repository";
import { Entity } from "@entity/domain/models/entity.model";
import { inject, injectable } from "inversify";

@injectable()
export class GetEntityByIdUseCase {
    constructor(
        @inject(EntityRepository)
        private readonly entityRepository: EntityRepository,
    ) { }

    async execute(entityId: number): Promise<Nullable<Entity>> {
        const entityResult = await this.entityRepository.getById(entityId);

        if (entityResult.isLeft()) {
            ToastManagerStore.error(entityResult.getLeftOrThrow().message);
        }

        return entityResult.fold(
            () => null,
            (entity) => entity,
        );
    }
}
